import { render, staticRenderFns } from "./payroll-history.vue?vue&type=template&id=1a4e8b5d&scoped=true&"
import script from "./payroll-history.vue?vue&type=script&lang=js&"
export * from "./payroll-history.vue?vue&type=script&lang=js&"
import style0 from "./payroll-history.vue?vue&type=style&index=0&id=1a4e8b5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e8b5d",
  null
  
)

export default component.exports